import type { z } from 'zod';

import type { ReportSchema } from '@ballerine/common';

import { MerchantDetailsContent } from '@/components/templates/composites/MerchantDetailsContent/MerchantDetailsContent';

type DFMerchantDetailsContentProps = {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'] | null;
  className?: string;
};

export const DFMerchantDetailsContent: React.FC<DFMerchantDetailsContentProps> = ({
  merchantDetails,
  className,
}) => (
  <MerchantDetailsContent
    merchantDetails={merchantDetails}
    className={className}
    showWebsite
    showAssociatedPersons
  />
);
